import { resolveBuildRunNumber } from '@/features/builds/utils/buildRunNumber';
import { resolvePipelineSlug } from '@/features/pipelines/utils/pipelineSlug';
import {
  buildStageDetailPath,
  buildStageExecutionDetailPath,
  buildSyntheticStageId,
} from '@/features/pipelines/utils/stagePaths';
import {
  buildEqFilterValue,
  mergeFilters,
  type GridFilters,
} from '@/ui/composites/grid/gridFilters';
import type { PipelineRunSummaryItemDto, PipelineStageExecutionListItemDto } from '@flowqa/shared';

export const buildPipelineRunHref = (row: PipelineRunSummaryItemDto): string | null => {
  const runNumber = resolveBuildRunNumber(row.buildKey);
  if (runNumber === null) return null;
  return `/pipelines/${resolvePipelineSlug({ id: row.pipelineId, name: row.pipelineName })}/runs/${String(runNumber)}`;
};

export const resolvePipelineRunStageCount = (row: PipelineRunSummaryItemDto): number =>
  row.stageTotal ?? row.stageSummaries?.length ?? 0;

export const resolveStageRunJobCount = (row: PipelineStageExecutionListItemDto): number =>
  row.jobTotal ?? row.jobSummaries?.length ?? 0;

export const buildStageRunJobRunFilters = ({
  pipelineExecutionId,
  stageName,
}: {
  pipelineExecutionId: string;
  stageName: string;
}): GridFilters =>
  mergeFilters(
    buildEqFilterValue('pipelineExecutionId', pipelineExecutionId),
    buildEqFilterValue('stageName', stageName),
  );

export const resolveStageRunLinks = (
  row: PipelineStageExecutionListItemDto,
): { executionHref: string; stageHref: string } => ({
  executionHref: buildStageExecutionDetailPath({
    stageExecutionId: row.id,
    pipelineId: row.pipelineId,
    stageName: row.stageName,
  }),
  stageHref: buildStageDetailPath(buildSyntheticStageId(row.pipelineId, row.stageName)),
});
